module.exports = __webpack_public_path__ + "static/media/bird-owl1.e57701d7.aac";